/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-unneeded-ternary */

import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Button,
  Input,
  Toggle,
  Loader,
  Drawer,
  Divider,
} from 'rsuite';
import {
  MdArrowBack,
  MdSave,
  MdBook,
  MdChevronRight,
} from 'react-icons/md';
import { toast } from 'react-toastify';
import { handleUrlBannerChange } from './components/utils/utils';
import {
  Container2,
  PageContainer,
  MainContent,
  PageHeader,
  Section,
  FormGroup,
  ModulesLinkCard,
} from './styles';
import StatusBadge from './components/StatusBadge';
import {
  getTreinamentoById,
  createTreinamento,
  updateTreinamento,
  getModulos,
} from '../../services/treinamentos';
import ListaModulos from './ListaModulos';

function EditarTreinamento({showEditarTreinamento, setShowEditarTreinamento, idTreinamento, fecharEditarTreinamento}) {
  const id  = idTreinamento;
  // const { id } = useParams();
  const history = useHistory();
  const isNew = !id || id === 'novo';

  // Estado geral
  const [loading, setLoading] = useState(!isNew);
  const [saving, setSaving] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);

  // Dados do treinamento
  const [titulo, setTitulo] = useState('');
  const [slug, setSlug] = useState('');
  const [descricao, setDescricao] = useState('');
  const [urlBanner, setUrlBanner] = useState('');
  const [urlBannerValid, setUrlBannerValid] = useState(true);
  const [urlValidationMessage, setUrlValidationMessage] = useState('');
  const [ativo, setAtivo] = useState(false);
  const [showModulos, setShowModulos] = useState(false);

  // Módulos (apenas para contagem)
  const [modulos, setModulos] = useState([]);

  // Carregar dados do treinamento
  const loadTreinamento = useCallback(async () => {
    if (isNew) return;

    setLoading(true);
    try {
      const data = await getTreinamentoById(idTreinamento);
      setTitulo(data.titulo || '');
      setSlug(data.slug || '');
      setDescricao(data.descricao || '');
      setUrlBanner(data.url_banner || '');
      setAtivo(data.ativo ?? true);
      setModulos(data.modulos || []);
    } catch {
      toast.error('Erro ao carregar treinamento');
      history.replace('/home/treinamentos');
    } finally {
      setLoading(false);
    }
  }, [id, isNew, history]);


  // Carregar módulos separadamente (para contagem atualizada)
  const loadModulos = useCallback(async () => {
    if (isNew) {
      setSaving(false);
      setTitulo('');
      setSlug('');
      setDescricao('');
      setUrlBanner('');
      setAtivo();
      return;
    }
    try {
      const data = await getModulos(id);
      setModulos(data || []);
    } catch {
      // Silencioso - já temos os módulos do treinamento
    }
  }, [id, isNew]);

  useEffect(() => {
    loadTreinamento();
    loadModulos();
  }, [loadTreinamento, loadModulos, showEditarTreinamento, idTreinamento]);

  // Gerar slug automaticamente
  const generateSlug = useCallback((text) => {
    return text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }, []);

  const handleTituloChange = useCallback((value) => {
    setTitulo(value);
    if (isNew || !slug) {
      setSlug(generateSlug(value));
    }
    setHasChanges(true);
  }, [isNew, slug, generateSlug]);

  // Salvar treinamento
  const handleSave = useCallback(async () => {
    if (!titulo.trim()) {
      toast.error('O título é obrigatório');
      return;
    }

    if (!slug.trim()) {
      toast.error('O slug é obrigatório');
      return;
    }

    setSaving(true);
    try {
      const data = {
        titulo,
        slug,
        descricao,
        url_banner: urlBanner,
        ativo: ativo ? true : false,
      };

      if (isNew) {
        const result = await createTreinamento(data);
        toast.success('Treinamento criado com sucesso!');
      } else {
        if(!handleUrlBannerChange(urlBanner, setUrlBannerValid, setUrlValidationMessage)){
          return
        }
        await updateTreinamento(id, data);
        toast.success('Treinamento salvo com sucesso!');
        setHasChanges(false);
      }
    } catch (error) {
      toast.error(error.message || 'Erro ao salvar treinamento');
    } finally {
      setSaving(false);
      setTitulo('');
      setSlug('');
      setDescricao('');
      setUrlBanner('');
      setAtivo(false);
      fecharEditarTreinamento();
    }
  }, [titulo, slug, descricao, urlBanner, ativo, isNew, id, history]);

  if (loading) {
    return (
      <PageContainer style={{ display: 'block' }}>
        <MainContent style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Loader size="lg" content="Carregando..." />
        </MainContent>
      </PageContainer>
    );
  }

  function fecharModulos() {
    setShowModulos(false);
  }
  function fecharEdicao() {
    fecharEditarTreinamento();
    setTitulo('');
    setSlug('');
    setDescricao('');
    setUrlBanner('');
    setAtivo();
  }

  return (
    <Drawer
    full
    open={showEditarTreinamento}
    onClose={() => fecharEdicao()}
    >
        <PageContainer>
      <MainContent>
        <PageHeader>
          <div
            className="back-button"
            onClick={() => fecharEdicao()}
          >
            <MdArrowBack />
            Voltar à Lista de Treinamentos
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <Button
              appearance="primary"
              onClick={handleSave}
              loading={saving}
              disabled={!hasChanges && !isNew}
            >
              <MdSave style={{ marginRight: 8 }} />
              {isNew ? 'Criar Treinamento' : 'Salvar'}
            </Button>
          </div>
        </PageHeader>


        <Section>
          <h2>Dados Gerais</h2>

          <FormGroup>
            <label>Título *</label>
            <Input
              value={titulo}
              onChange={handleTituloChange}
              placeholder="Ex: Auxiliar de Cozinha"
            />
          </FormGroup>

          <FormGroup>
            <label>Slug *</label>
            <Input
              value={slug}
              onChange={(v) => {
                setSlug(generateSlug(v));
                setHasChanges(true);
              }}
              placeholder="auxiliar-de-cozinha"
            />
            <div className="hint">
              URL: /treinamentos/{slug || 'slug-do-treinamento'}
            </div>
          </FormGroup>

          <FormGroup>
            <label>Descrição</label>
            <Input
              as="textarea"
              rows={4}
              value={descricao}
              onChange={(v) => {
                setDescricao(v);
                setHasChanges(true);
              }}
              placeholder="Descrição do treinamento..."
            />
          </FormGroup>

          <FormGroup>
            <label>URL do Banner</label>
            <Input
              value={urlBanner}
              onChange={(v) => {
                handleUrlBannerChange(v, setUrlBannerValid, setUrlValidationMessage);
                setUrlBanner(v);
                setHasChanges(true);
              }}
              placeholder="https://exemplo.com/imagem-banner.jpg"
            />
              {!urlBannerValid && (
                <div style={{ color: 'red' }}>{urlValidationMessage}</div>
              )}
            {urlBannerValid && urlBanner && (
              <div style={{ marginTop: 8 }}>
                <img
                  src={urlBanner}
                  alt="Preview do banner"
                  style={{
                    maxWidth: '100%',
                    maxHeight: 200,
                    borderRadius: 8,
                    border: '1px solid #ddd',
                  }}
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              </div>
            )}
          </FormGroup>

          <FormGroup>
            <label>Status</label>
            <div style={{ display: 'flex', alignItems: 'center',  gap: 15 }}>
              <Toggle
                checked={ativo}
                onChange={(v) => {
                  setAtivo(v);
                  setHasChanges(true);
                }}
              />
              <div style={{ marginBottom: 8 }}>
              <StatusBadge variant={ativo ? 'ativo' : 'inativo'}>
                {ativo ? 'Ativo' : 'Inativo'}
              </StatusBadge>
              </div>
            </div>
          </FormGroup>

          {/* {!isNew ? (
            <ModulesLinkCard onClick={() => setShowModulos(true)}>
              <div className="icon">
                <MdBook size={24} />
              </div>
              <div className="info">
                <h4>Módulos do Treinamento</h4>
                <p>{modulos.length} módulo{modulos.length !== 1 ? 's' : ''} cadastrado{modulos.length !== 1 ? 's' : ''}</p>
              </div>
              <div className="arrow">
                <MdChevronRight size={24} />
              </div>
            </ModulesLinkCard>
          ) : null} */}
                      <Divider style={{ margin: '1px' }} />
          
      <ListaModulos
              showModulos={showModulos}
              setShowModulos={setShowModulos}
              idTreinamentoModulos={idTreinamento}
              fecharModulos={fecharModulos}
            />
        </Section>
      </MainContent>
      </PageContainer>
      </Drawer>
  );
}

EditarTreinamento.propTypes = {
  showEditarTreinamento: PropTypes.bool.isRequired,
  setShowEditarTreinamento: PropTypes.func.isRequired,
  idTreinamento: PropTypes.number.isRequired,
  fecharEditarTreinamento: PropTypes.func.isRequired,
};

export default EditarTreinamento;
